import { EventStructure } from "../types";
import { attachBehavioralInference } from "./behavior";
import { attachPersonaDescription } from "./persona";

export function attachSessionDescription(event: EventStructure) {
  return attachPersonaDescription(attachBehavioralInference(event));
}
